import * as React from "react";

import { EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

import Router from "./Router";
import DataProvider from "./DataProvider";
import NotificationProvider from "./NotificationProvider";

import { msalInstance } from "../common/msal";
import { BugsnagErrorBoundary } from "../common/bugsnag";

export default function App() {
  // this will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  // this will adjust our active account whenever somebody signs in or out
  msalInstance.addEventCallback((event) => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS &&
      event.payload["account"]
    ) {
      const account = event.payload["account"];
      msalInstance.setActiveAccount(account);
    }
  });

  const accounts = msalInstance.getAllAccounts();

  // set active user if an account is already present
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  return (
    <BugsnagErrorBoundary>
      <MsalProvider instance={msalInstance}>
        <DataProvider>
          <NotificationProvider>
            <Router />
          </NotificationProvider>
        </DataProvider>
      </MsalProvider>
    </BugsnagErrorBoundary>
  );
}
